import { Form } from "antd";
import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect } from "react";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
import FormCard from "../../components/card/FormCard";
import FormItemInput from "../../components/form-item/form-item-input";
import FormItemInputSelect from "../../components/form-item/form-item-input-select";
import FormButton from "../../components/FormButton";
import { $api } from "../../helper";
import { statusShowMock, tokenMock } from "../../helper/mock";
import { useNavigate, useSearchParams } from "react-router";
import { useNotify } from "../../helper/notify";

export default function AddTicketCategory() {
  const [form] = Form.useForm();
  const notify = useNotify();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { mutate, isPending } = $api.useMutation(
    "post",
    "/site-api/v1/ticket/category/",
  );
  const detail = $api.useMutation(
    "get",
    "/site-api/v1/ticket/category-detail/",
  );
  const update = $api.useMutation("put", "/site-api/v1/ticket/category/");
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("ایجاد دسته بندی جدید");
    if (searchParams.get("u_id")) {
      detail.mutate({
        headers: {
          Authorization: tokenMock,
          lang: "fa",
        },
        params: {
          query: {
            category_u_id: searchParams.get("u_id") ?? "",
          },
        },
      });
    }
  }, []);

  useEffect(() => {
    if (searchParams.get("u_id") && detail.data) {
      Object.entries(detail.data?.data).forEach(([key, value]) => {
        form.setFieldValue(key, value.toString());
      });
    }
  }, [detail.data]);

  const onFinish = (
    values: { status: string; title: string },
    redirect = true,
  ) => {
    if (searchParams.get("u_id")) {
      update.mutate(
        {
          body: {
            ...values,
            status: +values.status,
            category_u_id: searchParams.get("u_id") ?? "",
          },
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate("/ticket-category");
            } else {
              window.location.href = window.location.pathname;
            }
          },
        },
      );
    } else {
      mutate(
        {
          body: { ...values, status: +values.status },
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate("/ticket-category");
            } else {
              window.location.href = window.location.pathname;
            }
          },
        },
      );
    }
  };

  return (
    <Form
      form={form}
      onFinish={(e) => onFinish(e)}
      layout="vertical"
      className="flex! flex-col! gap-6!"
    >
      <CustomBreadcrumb
        items={[
          {
            title: "دسته بندی تیکت",
            href: "/ticket-category",
          },
          {
            title: "ایجاد دسته بندی جدید",
          },
        ]}
      />
      <FormCard
        subTitle="تعریف و تنظیمات پایه مربوط به دسته‌بندی"
        title="اطلاعات اصلی دسته‌بندی"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <FormItemInput
            name={"title"}
            rules={[
              {
                required: true,
                message: "نام دسته بندی اجباری است",
              },
            ]}
            className="col-span-1"
            label="نام دسته بندی"
            inputProps={{
              placeholder: "لطفا نام دسته بندی خود را وارد کنید.",
            }}
          />
          <FormItemInputSelect
            className="col-span-1"
            name={"status"}
            rules={[
              {
                required: true,
                message: "انتخاب وضعیت اجباری است",
              },
            ]}
            label="وضعیت"
            inputProps={{
              placeholder: "لطفا وضعیت نمایش محصول خود را انتخاب کنید.",
              options: statusShowMock,
            }}
          />
        </div>
      </FormCard>
      <FormButton
        isPending={isPending}
        ActionSaveAndStay={() => {
          form.validateFields().then(() => {
            onFinish(form.getFieldsValue(), false);
          });
        }}
      />
    </Form>
  );
}
